export default {
  apiHostTL: 'https://test-truckloads-pay-api.truckerpath.com/truckloads-pay/api/v1.0',
  apiHost: 'https://test-api.truckerpath.com',
  apiELD: 'https://qa-eld-api.truckerpath.com/api/v2.0',
  apiBjorn: 'https://test-bjorn-api.truckerpath.com',
  apiHere: 'https://router.hereapi.com/v8',
  hereMapsApiKey: 'ossFwZuLtG6UBfU1nBYfnST0x6XhkGbLko7JKOhLYAA',
  hereMapsApiId: 'n56hSg4odZ2fEWn9j1UO',
  hereMapsApiCode: 'MSRyOqwzlKLe0zQsLKRx-w',
  apiMessage: 'https://test-cloud.truckerpath.com',
  eldUrl: 'http://eld-order-v2.qa-websit.truckerpath.com',
  googleMapsApiKey: 'AIzaSyDeWM4SpCW_wBZQMOb3xGbV9E-l9knSUVk',
  stripeKey: 'pk_test_oMG23PXwGj9dTTHsdvtUksDH',
  grecaptchaKey: '6Lcv4DUbAAAAAOLCJMgLXeRCtcLeN9LEJh8pQEg0',
  messagePushWss: 'wss://test-message.truckerpath.com',
  env: 'test',
  newVersion: 'https://tl-carrier.qa-websit.truckerpath.com/',
};



// WEBPACK FOOTER //
// ./src/test-config.js